export default "__VITE_ASSET__C3yCogHx__"